import React from 'react'
import { Box, HStack, Button } from '@chakra-ui/react'

interface SignupBackButtonProps {
  onBack: () => void
  label?: string
}

export const SignupBackButton: React.FC<SignupBackButtonProps> = ({
  onBack,
  label = 'Startseite',
}) => {
  return (
    <Box
      minH="60px"
      bg="bg.subtle"
      borderBottom="1px solid"
      borderColor="border.subtle"
      boxShadow="0px 2px 4px 0px #18181B1A, 0px 0px 1px 0px #18181B4D;"
    >
      <HStack
        as="header"
        justify="flex-start"
        align="center"
        w="full"
        h="60px"
        px={{ base: 4, md: 6 }}
        py={3}
        gap={1}
      >
        <Button
          variant="outline"
          size="lg"
          borderRadius="Radii/Semantic_tokens/l2"
          colorPalette="gray"
          onClick={onBack}
          borderColor="gray.muted"
          px={5}
          py="2px"
          gap={3}
        >
          {label}
        </Button>
      </HStack>
    </Box>
  )
}
